import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.1_@parcel+watcher@2.4.1_@types+node@20.17.12_encoding@0.1.13_eslint@8.57.1_ioredis@_rurasghaw7d5suraucihyoa26e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.1_@parcel+watcher@2.4.1_@types+node@20.17.12_encoding@0.1.13_eslint@8.57.1_ioredis@_rurasghaw7d5suraucihyoa26e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "dev-only": () => import("/vercel/path0/apps/web/middleware/devOnly.ts")
}